import { createMergeReducer } from '../utils/reducer'

export interface CollectionDetail {
  header?: string
  collectionType?: string
  totalCardSize?: number
  titleIds: string[]
}

export type TitleIdToCollections = {
  [titleId: string]: CollectionDetail[] | undefined
}

export const reducer = createMergeReducer(
  t => t.collections,
  {} as TitleIdToCollections
)
